import { render, staticRenderFns } from "./SamBadge.vue?vue&type=template&id=5aba47ea&scoped=true&"
import script from "./SamBadge.vue?vue&type=script&lang=js&"
export * from "./SamBadge.vue?vue&type=script&lang=js&"
import style0 from "./SamBadge.vue?vue&type=style&index=0&id=5aba47ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aba47ea",
  null
  
)

export default component.exports